import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';

import Image from './Image';

class ImageContainer extends React.Component {

    static propTypes = {
        mediaId: PropTypes.string,

        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
    };

    render()
    {
        const style = {
            width: this.props.width,
            height: this.props.height,
        };

        const classes = classNames({
            'bg-center overflow-hidden': true,
            'flex bg-opacity-50 border-4 bg-no-repeat justify-center': ! this.props.media,
        });

        return <div className={classes} style={style}>
            {
                this.renderImage()
            }
        </div>;
    }

    renderImage()
    {
        if (! this.props.media) {
            return <svg viewBox="0 0 20 20" fill="currentColor" className="w-3/6 text-gray-300"><path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd"></path></svg>;
        }

        return <Image {...this.props} />;
    }
}

const mapStateToProps = (state, ownProps) => ({
    media: ownProps.media || _.find(state.media, ['id', ownProps.mediaId])
});

export default connect(mapStateToProps)(ImageContainer);
